<template>
  <div class="v-modal">
    <div class="v-modal__header">
      <span>{{ assessmentType[0].toUpperCase() + assessmentType.slice(1) }} Assessment</span>
      <div @click="close()" class="close"></div>
    </div>
    <div class="v-modal__body">
      <div class="row">
        <div v-if="!user" class="col text-center">
          <p>You have just started a new {{ assessmentType }} assessment. Whenever you want to open this {{ assessmentType }} assessment in the future, you can use the following code:</p>
          <p class="lead">{{scenarioCode}}</p>
          <p><i>Please save this code.</i> Write it down, or copy and paste it into a text file.</p>
        </div>
        <div v-else class="col text-center">
          <p>You have just started a new {{ assessmentType }} assessment. The assessment was saved to your account. At any time in the future, you can open this {{ assessmentType }} assessment from your account. All changes that you make will be automatically saved, too.</p>
        </div>
      </div>
    </div>
    <div class="v-modal__footer">
      <button @click="next()" class="btn btn-primary">Next</button>
    </div>
  </div>
</template>

<script>
import { assessment } from "@/services/assessment-model.js";
import { scenarioCountryCropsCreator, scenarioCreator, scenarioProcessesLoader } from "@/services/entity-model.js";
import { closeModal } from "@/services/modal-model";
import { userModel } from "@/services/user-model";

export default {
  name: "Scenario1",
  props: {
    modal: {type: Object},
    tempScenario: {type: Object}
  },
  computed: {
    user() {
      return userModel.user;
    },
    assessmentType() {
      return assessment.assessmentType.name;
    },
    scenarioCode() {
      return assessment.scenario ? assessment.scenario.code : "0000000000";
    }
  },
  mounted() {
    const tempScenario = this.tempScenario;
    const user = this.user;
    const assessmentType = this.assessmentType;
    if (tempScenario.countryCrops || tempScenario.processes) {
      scenarioCreator.load(
        tempScenario.name, tempScenario.type, tempScenario.unitID, tempScenario.quantity,
        tempScenario.csvDelimiter, tempScenario.csvQuoteChar, tempScenario.csvHeaders,
        scenarios => {
          if ((user != this.user) || (assessmentType != this.assessmentType)) {
            return;
          }

          assessment.setScenario(scenarios[0], false);

          if (user != null) {
            user.saveScenario(scenarios[0].code);
          }

          if ((assessmentType == "commodity") && (tempScenario.countryCrops.length > 0)) {
            const countryCrop = tempScenario.countryCrops[0];
            const scenarioCode = this.scenarioCode;
            scenarioCountryCropsCreator.load(
              scenarioCode, ...Object.values(countryCrop),
              scenarioCountryCrops => {
                if (scenarioCode != this.scenarioCode) {
                  return;
                }

                assessment.loadScenarioDerivedEntities();
              }
            );
          } else if ((assessmentType == "business") && (tempScenario.processes.length > 0)) {
            const scenarioCode = this.scenarioCode;
            const nextProcess = processes => {
              if (processes.length > 0) {
                scenarioProcessesLoader.load(
                  scenarioCode, null, processes[0].name, processes[0].abstraction, processes[0].effluent, processes[0].loss, processes[0].csv, processes[0].geometry,
                  scenarioProcesses => {
                    if (scenarioCode != this.scenarioCode) {
                      return;
                    }

                    nextProcess(processes.slice(1));
                  }
                );
              } else {
                assessment.loadScenarioDerivedEntities();
              }
            };
            nextProcess(tempScenario.processes);
          }
        }
      );
    }
  },
  methods: {
    close() {
      closeModal(this.modal);
    },
    next() {
      this.close();
      assessment.nextStep();
    }
  }
}
</script>
